import * as axios from 'axios';
import moment from 'moment';
import constant from '../constant';
import { getAuthHeader, setsessionStorage, setStorage } from '../utils';

export const employementTypeList = () => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-employement-type`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
};


export const salaryList = () => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-salary-lists`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
};


export const functionalAreaList = () => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-functional-area-lists`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
};


export const jobIndustryList = () => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-job-industry-lists`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
};

export const industryEmployerLists = () => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-employer-industry-lists`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
};

export const getDesignationFullList = () => {
    const url = `${process.env.REACT_APP_BASE_URL}/seo/designation-full-list`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
};

export const citySearch = (KEYWORD) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-city-search?KEYWORD=${KEYWORD}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
};
export const getLocalities = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-get-localities`;
    return axios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const qualificationList = () => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-qualification-list`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const jobQuestionList = (KEYWORD) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-job-question-list?KEYWORD=${KEYWORD}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const searchSkill = (SKILL) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-skill-search?SKILL=${SKILL}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}
export const educationqualificationList = (QUALIFICATION_ID) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-education-qualification?QUALIFICATION_ID=${QUALIFICATION_ID}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const courseSpecializationList = (EDUCATION_QUALIFICATION_ID) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-course-specialization-list?EDUCATION_QUALIFICATION_ID=${EDUCATION_QUALIFICATION_ID}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const jobRoleList = (FUNCTIONAL_AREA_ID) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-job-role-list?FUNCTIONAL_AREA_ID=${FUNCTIONAL_AREA_ID}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const uploadJobpostionDetails = (file) => {

    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-upload-job-postions-details`;
    return axios.post(url, file, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const postJob = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-post-job`;
    return axios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const postJobSteps = (model, step) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-job/${step}`;
    return axios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const postCampusJob = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-post-campus-job`;
    return axios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const postCampusInternship = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-post-internship`;
    return axios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const postedCampusJobsList = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-posted-campus-jobs-list`;
    return axios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const postedCampusInternshipList = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-posted-campus-internship-list`;
    return axios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const postedOppurtunitiesList = (page, filter) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-posted-opportunities/${page}/${filter}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const jobComment = (jobId) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh/job/comment/${jobId}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const closejob = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-close-job`;
    return axios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const closeCampusJob = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-close-campus-job`;
    return axios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}
export const closeInternship = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-close-internship`;
    return axios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const addJobComment = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh/job/comment`;
    return axios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const deleteJobComment = (commentId) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh/job/comment/${commentId}`;
    return axios.delete(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const JobDetailById = (JOB_ID) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh/job/${JOB_ID}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
};

export const updateJob = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/update-Jobs`;
    return axios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const jobApplications = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-job-application-list`;
    return axios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const UpdateJobResponse = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-update-job-response`;
    return axios.put(url,model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const UpdateCampusJobResponse = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-update-campus-job-response?JOB_ID=${model.JOB_ID}&STUDENT_ID=${model.STUDENT_ID}&STATUS_ID=${model.STATUS_ID}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const UpdateOffCampusJobResponse = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-update-off-campus-job-response?JOB_ID=${model.JOB_ID}&STUDENT_ID=${model.STUDENT_ID}&STATUS_ID=${model.STATUS_ID}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const UpdateCampusInternshipResponse = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-update-campus-internship-response?JOB_ID=${model.JOB_ID}&STUDENT_ID=${model.STUDENT_ID}&STATUS_ID=${model.STATUS_ID}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const UpdateOffCampusInternshipResponse = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-update-off-campus-internship-response?JOB_ID=${model.JOB_ID}&STUDENT_ID=${model.STUDENT_ID}&STATUS_ID=${model.STATUS_ID}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}




export const getInterviewStatus = () => {
    const url = `${process.env.REACT_APP_BASE_URL}/get-interview-status`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const postedJobsCount = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-posted-jobs-count`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const JobSearchByTitle = (KEYWORD) => {
    const url = `${process.env.REACT_APP_BASE_URL}/job-search-by-title?KEYWORD=${KEYWORD}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
};


export const applicationstatuslist = () => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-application-status-list`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const forwardCandidateMail = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/forward-profile`;
    return axios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const SendMessage = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/send-message`;
    return axios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const ForwardProfile = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/forward-profile`;
    return axios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const updateStatus = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh/job-status`;
    return axios.patch(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const updateCampusJobStatus = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/update-employer-campus-job-status`;
    return axios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const updateCampusInternshipStatus = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/update-employer-campus-intership-status`;
    return axios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const sendcandidaterating = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/send-candidate-rating`;
    return axios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })

}

export const employersuggestions = (KEYWORD) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-employer-suggestion?KEYWORD=${KEYWORD}`;
    return axios.get(url).then((res) => {
        return res.data;
    })

}


export const individualEmailSuggestion = (KEYWORD) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-individual-employer-suggestion?KEYWORD=${KEYWORD}`;
    return axios.get(url).then((res) => {
        return res.data;
    })

}


export const verifyEmployer = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-verify-employer`;
    return axios.post(url, model).then((res) => {
        return res.data;
    })

}




export const verifyEmployerOTP = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-verify-employer-otp`;
    return axios.post(url, model).then((res) => {
        return res.data;
    })

}

export const postDirectJob = (token, model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-direct-post-job`;
    const header = {
        headers: { Authorization: "Bearer " + token }
    };
    return axios.post(url, model, header).then((res) => {
        return res.data;
    })
}

export const addNewEmployer = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-add-new-employer-for-job-posting`;

    return axios.post(url, model).then((res) => {
        return res.data;
    })
}

export const verifyNewEmployerOTP = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-new-employer-verify-otp`;
    return axios.post(url, model).then((res) => {
        return res.data;
    })
}

export const verifyNewEmployerOTPOutPlacement = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/outplacement/ejsh-new-employer-verify-otp`;
    return axios.post(url, model).then((res) => {
        if (res.data.status) {
            setStorage(constant.keys.token, res.data.result.token);
            setStorage(constant.keys.userDetails, res.data.result);
            setsessionStorage(constant.keys.token, res.data.result.token);
            setStorage(constant.keys.loggedIn, moment().format('X'));
            setStorage(constant.keys.remeber_me, true);
        }
        return res.data;
    })
}

export const reScheduleZoomMeeting = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/re-schedule-meeting`;
    return axios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}






export const setInterviewStatus = (interviewStatus) => {
    const url = `${process.env.REACT_APP_BASE_URL}/set-interview-status`;
    return axios.post(url, interviewStatus, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const iHaveHRMSSubscription = () => {
    const url = `${process.env.REACT_APP_BASE_URL}/i-have-hrms-subscription`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const RecruiterMessage = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/send-recruiter-message`;
    return axios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const RecruiterMessageList = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/recruiter-message-list?JOB_ID=${model.JOB_ID}&CANDIDATE_ID=${model.CANDIDATE_ID}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        console.log(res.data)
        return res.data;
    })
}


export const addRemark = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/add-remark`;
    return axios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const campusJobApplications = (model) => {
    debugger
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-campus-job-application-list?JOB_ID=${model.JOB_ID}&limit=${model.limit}&page=${model.page}&SELECTION_PROCESS=${model.SELECTION_PROCESS}&KEYWORD=${model.keyword}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const OffcampusJobApplications = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-off-campus-job-application-list?JOB_ID=${model.JOB_ID}&limit=${model.limit}&page=${model.page}&SELECTION_PROCESS=${model.SELECTION_PROCESS}&KEYWORD=${model.keyword}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const campusInternshipApplications = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-campus-internship-application-list?JOB_ID=${model.JOB_ID}&limit=${model.limit}&page=${model.page}&SELECTION_PROCESS=${model.SELECTION_PROCESS}&KEYWORD=${model.keyword}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const OffCampusInternshipApplications = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-off-campus-internship-application-list?JOB_ID=${model.JOB_ID}&limit=${model.limit}&page=${model.page}&SELECTION_PROCESS=${model.SELECTION_PROCESS}&KEYWORD=${model.keyword}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const InternshipDetailById = (JOB_ID) => {
    const url = `${process.env.REACT_APP_BASE_URL}/internship-detail-by-id?JOB_ID=${JOB_ID}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
};

export const updateInternship = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/update-internships`;
    return axios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const evaluateProfiles = (job_id) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh/job/profile/evaluator/${job_id}`;
    return axios.post(url, {}, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const suggestedProfiles = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh/job/profile/suggested`;
    return axios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}